import MyAccount from '@/Pages/MyHub/MyAccount';
import { RoutePath } from '@/Routes/RoutePath';
import { ReactComponent as MyAccountIcon } from '@skytvnz/sky-app-style/lib/assets/svg/icons/icon_my_account.svg';
import { ReactComponent as ManageDevicesIcon } from '@skytvnz/sky-app-style/lib/assets/svg/icons/icon_manage_devices.svg';
import ManageDevices from '@/Pages/MyHub/ManageDevices';
import { useMemo } from 'react';
import { Menu, MenuItemProps } from '@/Pages/MyHub/Constants';
import { Flags, useFeatureFlag } from './useFeatureFlags';

const useMyHubMenu = () => {
  const { isOn: isPUJEnabled } = useFeatureFlag(Flags.PACKAGE_UPGRADE_JOURNEY);

  const menuList = useMemo(() => {
    const menuListConfig: Array<MenuItemProps> = [
      {
        icon: MyAccountIcon,
        label: 'My Account',
        value: Menu.MyAccount,
        link: RoutePath.myHubManagePackages,
        component: MyAccount,
        isVisible: isPUJEnabled,
      },
      {
        icon: ManageDevicesIcon,
        label: 'Manage Devices',
        value: Menu.ManageDevices,
        link: RoutePath.myHubManageDevices,
        component: ManageDevices,
        isVisible: true,
      },
    ];
    return menuListConfig.filter(menu => menu.isVisible);
  }, [isPUJEnabled]);

  return { menuList };
};

export default useMyHubMenu;
